import {
  Body,
  Card,
  EmptyState,
  ErrorMessage,
  LoadingState,
  PageHeader,
  Subtitle,
  VBadge,
  VStatusIcon,
  // VTooltip,
  // VTooltipContent,
  // VTooltipTrigger,
  // cn,
} from '@vrzl/ui';
// import { Calendar, Search, UserRound } from 'lucide-react';
import { Calendar, Search } from 'lucide-react';
import { Link, useSearchParams } from 'react-router';

import { useDebouncedValue } from '@/domains/general/hooks/useDebouncedValue';
import { ManualSyncButton } from '@/domains/sync';

import {  useEvents } from '../api/queries';
// import { useAssignees, useEvents } from '../api/queries';
import {
  extractionStatusIcon,
  extractionStatusLabels,
  statusBadgeColor,
  statusLabels,
} from '../constants';
// import { type AssigneeSelection } from '../lib/assigneeFilter';
import { DEFAULT_STATUS_ORDER, type StatusOrder } from '../lib/statusOrder';

// import { AssigneeFilter } from './assigneeFilter';
import { ExtractionStatusTooltip } from './extractionStatusTooltip';
import { StatusOrderFilter } from './statusOrderFilter';

export function Events() {
  const [searchParams, setSearchParams] = useSearchParams();
  const searchTerm = searchParams.get('search') ?? '';
  // const assignee = searchParams.get('assignee');
  const debouncedSearchTerm = useDebouncedValue(searchTerm, 300);

  const statusOrderParam = searchParams.get('statusOrder');
  const statusOrder: StatusOrder =
    statusOrderParam === 'open-first' ? 'open-first' : DEFAULT_STATUS_ORDER;

  const handleStatusOrderChange = (value: StatusOrder) => {
    const next = new URLSearchParams(searchParams);
    if (value === DEFAULT_STATUS_ORDER) next.delete('statusOrder');
    else next.set('statusOrder', value);
    setSearchParams(next, { replace: true });
  };

  const { data, isPending, error } = useEvents({
    search: debouncedSearchTerm || undefined,
    statusOrder: statusOrder !== DEFAULT_STATUS_ORDER ? statusOrder : undefined,
    // assignee: assignee ?? undefined,
  });
  // const { data: assigneesData } = useAssignees();

  {/*Er zijn nog onduidelijkheden hoe we assignee kunnen opvragen, het is niet de bedoeling om rollen weer te geven.*/}
  // const handleAssigneeChange = (value: AssigneeSelection) => {
  //   const next = new URLSearchParams(searchParams);
  //   if (value === null) next.delete('assignee');
  //   else next.set('assignee', value);
  //   setSearchParams(next, { replace: true });
  // };

  return (
    <div>
      <PageHeader
        title="Evenementen"
        description="Overzicht van alle ingediende evenementen voor beoordeling"
        action={
          <div className="flex items-center gap-2">
            <StatusOrderFilter value={statusOrder} onChange={handleStatusOrderChange} />
            <ManualSyncButton />
          </div>
        }
      />

      {/*Er zijn nog onduidelijkheden hoe we assignee kunnen opvragen, het is niet de bedoeling om rollen weer te geven.*/}
      {/*<div className="mb-4">
        <AssigneeFilter
          value={assignee}
          assignees={assigneesData?.items ?? []}
          onChange={handleAssigneeChange}
        />
      </div>*/}

      {isPending && <LoadingState />}
      {error && <ErrorMessage error={error} />}


      {data && (
        <div className="flex flex-col gap-3">
          {data.items.map((event) => (
            <Card
              key={event.id}
              asChild
              interactive
              className="flex items-center justify-between"
            >
              <Link to={`/events/${event.id}/overview`}>
                <div>
                  <Body weight="medium" className="text-card-foreground">
                    {event.name}
                  </Body>
                  <Subtitle className="mt-1 flex items-center gap-1.5">
                    <Calendar className="size-3.5 shrink-0" aria-hidden />
                    {event.eventDate ? (
                      <span>Evenement: {event.eventDate}</span>
                    ) : (
                      <span className="italic">Evenementdatum onbekend</span>
                    )}
                    {event.location && <span>· {event.location}</span>}
                    
                    {/*Er zijn nog onduidelijkheden hoe we assignee kunnen opvragen, het is niet de bedoeling om rollen weer te geven.*/}
                    {/*<span aria-hidden>·</span>*/}
                    {/*<VTooltip>*/}
                      {/*<VTooltipTrigger asChild>*/}
                        {/* span, geen button: de kaart is al een <Link> en geneste interactieve elementen zijn invalide */}
                        {/*<span
                          role="img"
                          aria-label={
                            event.assignee
                              ? `Toegewezen: ${event.assignee}`
                              : 'Niet toegewezen'
                          }
                          className={cn(
                            'inline-flex cursor-help',
                            !event.assignee && 'opacity-40',
                          )}
                        >
                          <UserRound className="size-3.5 shrink-0" aria-hidden />
                        </span>
                      </VTooltipTrigger>
                      <VTooltipContent>
                        {event.assignee ?? 'Niet toegewezen'}
                      </VTooltipContent>
                    </VTooltip>*/}
                  </Subtitle>
                </div>
                <div className="flex items-center gap-2">
                  <VBadge color={statusBadgeColor[event.status]}>
                    {statusLabels[event.status]}
                  </VBadge>
                  {event.extractionStatus && (
                    <ExtractionStatusTooltip
                      status={event.extractionStatus}
                      error={event.extractionError}
                    >
                      <VStatusIcon
                        {...extractionStatusIcon[event.extractionStatus]}
                        label={extractionStatusLabels[event.extractionStatus]}
                      />
                    </ExtractionStatusTooltip>
                  )}
                </div>
              </Link>
            </Card>
          ))}

          {data.items.length === 0 && (
            <EmptyState
              icon={Search}
              title={debouncedSearchTerm ? `Geen resultaten voor "${debouncedSearchTerm}"` : 'Geen evenementen gevonden'}
            />
          )}
        </div>
      )}
    </div>
  );
}
